// extracted by mini-css-extract-plugin
module.exports = {"navbar":"aside_navbar_navbar__1Q9K-","button":"aside_navbar_button__3x158"};